import { Stack, styled } from '@mui/material';

export const BoxItemAll = styled(Stack, {
  shouldForwardProp: prop => prop !== 'stateColor',
})<{ stateColor?: string }>(({ stateColor }) => ({
  padding: '10px 16px',
  background: stateColor,
}));
